import { type CSSProperties, type ReactNode } from 'react'
import './LoadingSpinner.css'

interface LoadingSpinnerProps {
  children?: ReactNode
  rounded?: boolean
  inButton?: boolean
  style?: CSSProperties
  className?: string
}

export const LoadingSpinner = ({
  children,
  rounded,
  inButton,
  style,
  className,
}: LoadingSpinnerProps) => {
  const modeClass = inButton
    ? ' loading-spinner--in-button'
    : rounded === undefined
      ? ' loading-spinner--auto'
      : ''

  const renderBorder = inButton || rounded === undefined || rounded === false
  const renderRounded = inButton || rounded === undefined || rounded === true

  return (
    <div
      className={`loading-spinner__wrap${className ? ` ${className}` : ''}${modeClass}`}
      style={style}
    >
      {renderBorder && <div className="loading-spinner__border" />}
      {renderRounded && (
        <div className="loading-spinner__rounded">
          <svg viewBox="0 0 100 100">
            <circle className="track" cx="50" cy="50" r="42" />
            <circle className="arc" cx="50" cy="50" r="42" pathLength="100" />
          </svg>
        </div>
      )}
      {children && children}
    </div>
  )
}
